
require('./bootstrap');

import Vue from 'vue';
import VueMq from 'vue-mq'


require('./registerGlobalComponents')


Vue.use(VueMq, {
    breakpoints: {
        smobil: 481,
        mobil: 769,
    }
})

Vue.component('layout', require('./components/Layout.vue').default);

// const app = new Vue({
//     el: '#app',
// })

new Vue({
    el: '#app',
});
